import styled from 'styled-components';

export const FilterContainer = styled.div`
  background: #ffffff;
  border: 0.4px solid #dfdfdf;
  border-radius: 8px;
  padding: 22px 26px;
`;

export const MainActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  .actions-left {
    display: flex;
    gap: 12px;
    align-items: center;
    flex: 1;
    label {
      display: none;
    }
    .badge-div {
      display: flex;
      gap: 10px;
    }
  }
  .actions-right {
    display: flex;
    gap: 12px;
    align-items: center;
    label {
      display: none;
    }
    .badge-div {
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }
  @media (max-width: 830px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;

    .actions-left {
      width: 100%;
    }

    .actions-right {
      width: 100%;
      justify-content: flex-end;
    }

    & > div:last-child {
      width: 100%;
      display: flex;
      justify-content: end;
      align-items: center;
    }
  }
  @media (max-width: 430px) {
    .actions-left {
      flex-direction: column;
      button {
        width: 100%;
        justify-content: end;
      }
    }
    .actions-right {
      flex-direction: column;
      align-items: stretch;
      .badge-div {
        justify-content: flex-end;
      }
    }
    & > div:last-child {
      justify-content: end;
      align-items: start;
    }
  }
`;

export const IconButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  border: 0.5px solid #d4d8dd;
  background: #ffffff12;
  color: #212529;
  height: 38px;
  transition: all 0.2s ease;
  width: fit-content;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  &.is-active {
    border: 0.5px solid #2d6cdf;
    background: #eff6ff;
    color: #2d6cdf;

    img {
      filter: invert(38%) sepia(84%) saturate(1108%) hue-rotate(195deg) brightness(93%)
        contrast(89%);
    }
  }
`;

export const IconButtonBox = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  .create-lead-btn {
    height: 38px;
    font-size: 14px;
    font-weight: 600;
  }

  @media (max-width: 830px) {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }

  @media (max-width: 430px) {
    button {
      width: 100%;
    }
  }
`;

export const ResetButton = styled.button`
  display: flex;
  align-items: center;
  gap: 3px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #1d3557;
  height: 38px;
  text-decoration: underline;

  &:hover {
    color: #1a202c;
  }
`;

export const ActionIcon = styled.img`
  width: 14px;
  height: 14px;
`;

export const FilterRow = styled.div`
  > div {
    > div > div {
      min-height: auto;
      > div > div {
        min-height: 38px;
      }
    }
  }
  [class*='-placeholder'] {
    color: #212529 !important;
    opacity: 1;
  }
  input::placeholder {
    color: #212529 !important;
    opacity: 1;
  }
`;
export const FilterRowLine = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: wrap;
  > div {
    min-width: 138px;
  }
  date-group {
    flex: 2;
  }

  .date-inputs {
    display: flex;
    gap: 10px;
    > div {
      width: 148px;
      flex: 1;
    }
  }
  @media (max-width: 768px) {
    gap: 15px 10px;

    > div {
      min-width: calc(50% - 10px);
    }

    .date-group {
      width: 100%;
      flex: 1 1 100%;
    }
  }

  @media (max-width: 480px) {
    > div {
      width: 100%;
    }

    .date-inputs {
      flex-direction: column;
      > div {
        width: 100%;
      }
    }
  }
`;

export const FilterLabel = styled.label`
  color: #212529;
  font-weight: 600;
  margin: 4px 0;
  display: block;
  font-size: 12px;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  > div {
    min-height: 38px;
    label {
      color: #6c757d;
      font-weight: 700;
      font-size: 12px;
    }
  }
  &.change-status {
    width: fit-content;
    min-width: fit-content;
  }
  .css-17hzp7b-control,
  .css-mkw8ed-control {
    background: #2d6cdf;
    border: none;
    box-shadow: none;
    cursor: pointer;
    border-radius: 10px;
    min-height: 38px;
    min-width: 158px;
    text-align: center;

    &:hover {
      border: none;
      box-shadow: none;
    }
  }
  .css-evdxjr-placeholder {
    color: white !important;
    font-weight: 700 !important;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
  }
  .css-1xc3v61-indicatorContainer,
  .css-15lsz6c-indicatorContainer {
    padding-left: 0;
    display: none;
    img {
      filter: brightness(0) invert(1);
      width: 12px;
      height: auto;
    }
  }

  [class*='-indicatorSeparator'] {
    display: none;
  }
  .search-inputs {
    width: 304px;
  }
  @media (max-width: 707px) {
    &.change-status {
      > div {
        flex: 0;
      }
    }
    > div {
      flex: 1 1 100%;
      max-width: none;
    }

    .search-inputs {
      max-width: none;
      width: 100%;
    }
  }
  @media (max-width: 430px) {
    &.change-status {
      width: 100%;
      > div {
        width: 100%;
        flex: 1;
      }
    }
  }
`;

export const Line = styled.div`
  border-top: 1px solid #e2e8f0;
  padding: 16px 0 0;
  width: 100%;
  margin-top: 23px;
  position: relative;
`;

export const ClearAllRow = styled.div`
  position: absolute;
  right: 0;
  bottom: 15px;
  &.close-x {
    bottom: auto;
    top: 10px;
    .close-x-icon {
      width: 20px;
      height: 20px;
    }
    @media (max-width: 865px) {
      top: -2px;
      right: -15px;
    }
  }
  @media (max-width: 1525px) {
    bottom: -18px;
  }
`;

export const ClearAllText = styled.span`
  cursor: pointer;
  color: #212529;
  font-size: 10px;
  font-weight: 700;
  text-decoration: underline;
  &:hover {
    color: #0284c7;
  }
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  padding: 4px;
`;

export const Icon = styled.img`
  width: 14px;
  height: 14px;
`;

export const SortButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #2b7fff;
  background: #eff6ff;
  height: 38px;
  font-size: 12px;
  color: #1447e6;
  cursor: pointer;
  font-weight: 500;
  gap: 8px;

  span {
    font-weight: 400;
    margin-left: 10px;
  }
`;
export const BadgeItemStatus = styled.div`
  height: 24px;
  min-width: 82px;
  border-radius: 22px;
  background: #15c7a71a;
  font-family: Nunito;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #15c7a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &.reassign {
    background: #fff0e5;
    color: #ff6a00;
  }

  &.take-lead {
    background: #e8f4ff;
    color: #2d6cdf;
  }
`;
export const CardRightIcon = styled.img``;
export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
`;

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ $color }) => $color || '#ccc'};
`;

export const OptionLabel = styled.span`
  color: #212529;
  font-size: 14px;
`;

export const MenuHeader = styled.div`
  padding: 8px 12px 4px;
  color: #64748e;
  font-size: 12px;
  font-weight: 600;
`;

export const MenuScrollContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const SelectBox = styled.div`
  max-height: 43px;
`;

// export const HiddenFileInput = styled.input`
//   display: none;
// `;
